"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineResourceManager = void 0;
const axios_1 = require("axios");
class OnlineResourceManager {
    constructor() {
        this.headersForEveryRequest = {};
        /**
        * Sets headers for every request on OnlineResourceManager.
        * These headers will be passed as an option to every request made afterwards.
        *
        * @param {HeadersInit} header e.g. => {Authorization: "Bearer dXNlckBleGFtcGxlLmNvbTpzZWNyZXQ", Accept: "text/html, application/xhtml+xml, application/xml;q=0.9"}
        */
        this.setHeadersForEveryRequest = (header) => {
            this.headersForEveryRequest = header;
        };
        /**
        * Returns an instance of OnlineResource initialized with a request.
        *
        * @param {string} resourcePath relative if accessing resource on localhost:3000 through V2 API,
        * eg. "/api/presentation", otherwise full path => "hostURL:hostPORT/endpoint"
        * @param {Method} [method=GET]  "GET" | "DELETE" | "HEAD" | "OPTIONS" | "POST" | "PUT" | "PATCH" | "PURGE" | "LINK" | "UNLINK"
        * @param {BodyInit} [body=] your JavaScript object put in the request's body
        * @param {AxiosRequestConfig} [options=] additional request options
        * @return {OnlineResource} instance of OnlineResource initialized with a request.
        */
        this.makeRequest = (resourcePath, method = "GET", body, options = {}) => {
            let extraOptions = { method: method, headers: this.headersForEveryRequest };
            if (Object.keys(options).length !== 0) {
                extraOptions = Object.assign(Object.assign({}, extraOptions), options);
            }
            if (body) {
                extraOptions["data"] = body;
            }
            extraOptions["url"] = resourcePath;
            return new OnlineResource(Object.assign({}, extraOptions));
        };
        /**
        * Returns an instance of OnlineResource initialized with a request (with additional "Content-Type": "application/json" header).
        *
        * @param {string} resourcePath relative if accessing resource on localhost:3000 through V2 API,
        * eg. "/api/presentation", otherwise full path => "hostURL:hostPORT/endpoint"
        * @param {Method} [method=GET] "GET" | "DELETE" | "HEAD" | "OPTIONS" | "POST" | "PUT" | "PATCH" | "PURGE" | "LINK" | "UNLINK"
        * @param {BodyInit} [body=] your JavaScript object put in the request's body
        * @param {AxiosRequestConfig} [options=] additional request options
        * @return {OnlineResource} instance of OnlineResource initialized with a request.
        */
        this.makeJSONRequest = (resourcePath, method = "GET", body, options = {}) => {
            let extraOptions = { method: method, headers: this.headersForEveryRequest };
            if (Object.keys(options).length !== 0) {
                extraOptions = Object.assign(Object.assign({}, extraOptions), options);
            }
            if (body) {
                extraOptions["data"] = body;
            }
            extraOptions["url"] = resourcePath;
            extraOptions["headers"] = Object.assign(Object.assign({}, extraOptions["headers"]), { "content-type": "application/json" });
            return new OnlineResource(Object.assign({}, extraOptions));
        };
    }
}
exports.OnlineResourceManager = OnlineResourceManager;
class OnlineResource {
    constructor(options) {
        this.getResponseData = () => __awaiter(this, void 0, void 0, function* () {
            try {
                axios_1.default.defaults.withCredentials = true;
                const response = yield (0, axios_1.default)(this.request)
                    .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code that falls out of the range of 2xx
                        throw Error("Server responded with: " + error.response.status);
                    }
                    else if (error.request) {
                        // The request was made but no response was received
                        throw Error("Server didn't respond to the request: " + error.request);
                    }
                    else {
                        // Something happened in setting up the request that triggered an Error
                        throw Error("The request was not constructed correctly: " + error.message);
                    }
                });
                return response.data;
            }
            catch (e) {
                return Promise.reject(new Error("Fetching response from url: " + this.request["url"] + " failed with exception: " + e + "\nStack trace: \n" + e.stack));
            }
        });
        this.getResponseDataWithHeaders = (headers) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                axios_1.default.defaults.withCredentials = true;
                const response = yield (0, axios_1.default)(this.request)
                    .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code that falls out of the range of 2xx
                        throw Error("Server responded with: " + error.response.status);
                    }
                    else if (error.request) {
                        // The request was made but no response was received
                        throw Error("Server didn't respond to the request: " + error.request);
                    }
                    else {
                        // Something happened in setting up the request that triggered an Error
                        throw Error("The request was not constructed correctly: " + error.message);
                    }
                });
                for (const header in headers) {
                    if (!((_a = response.headers[`${header}`]) === null || _a === void 0 ? void 0 : _a.includes(headers[header]))) {
                        throw Error(`The header ${header} was not equal to ${headers[header]}`);
                    }
                }
                return response.data;
            }
            catch (e) {
                return Promise.reject(new Error("Fetching response from url: " + this.request["url"] + " failed with exception: " + e + "\nStack trace: \n" + e.stack));
            }
        });
        this.getDataAsJSON = () => __awaiter(this, void 0, void 0, function* () {
            var _b;
            try {
                axios_1.default.defaults.withCredentials = true;
                const response = yield (0, axios_1.default)(this.request)
                    .catch((error) => {
                    if (error.response) {
                        // The request was made and the server responded with a status code that falls out of the range of 2xx
                        throw Error("Server responded with: " + error.response.status);
                    }
                    else if (error.request) {
                        // The request was made but no response was received
                        throw Error("Server didn't respond to the request: " + error.request);
                    }
                    else {
                        // Something happened in setting up the request that triggered an Error
                        throw Error("The request was not constructed correctly: " + error.message);
                    }
                });
                if (!((_b = response.headers["content-type"]) === null || _b === void 0 ? void 0 : _b.includes("application/json"))) {
                    throw Error("MIME was not set to 'application/json' in response");
                }
                return response.data;
            }
            catch (e) {
                return Promise.reject(new Error("Fetching response from url: " + this.request["url"] + " failed with exception: " + e + "\nStack trace: \n" + e.stack));
            }
        });
        this.getResponseRaw = () => __awaiter(this, void 0, void 0, function* () {
            try {
                axios_1.default.defaults.withCredentials = true;
                const response = yield (0, axios_1.default)(this.request)
                    .catch((error) => {
                    if (error.response) {
                        return error.response;
                    }
                    else if (error.request) {
                        return error.request;
                    }
                    else {
                        return error.message;
                    }
                });
                return response;
            }
            catch (e) {
                return Promise.reject(new Error("Fetching response from url: " + this.request["url"] + " failed with exception: " + e + "\nStack trace: \n" + e.stack));
            }
        });
        this.abort = () => {
            this.abortController.abort();
        };
        this.abortController = new AbortController();
        options.signal = this.abortController.signal;
        this.request = options;
    }
}
